import { render, staticRenderFns } from "./fin-manager.vue?vue&type=template&id=a624673a&scoped=true"
import script from "./fin-manager.vue?vue&type=script&lang=js"
export * from "./fin-manager.vue?vue&type=script&lang=js"
import style0 from "./fin-manager.vue?vue&type=style&index=0&id=a624673a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a624673a",
  null
  
)

export default component.exports